import { defineStore } from "pinia";
import api from "./api";

const API_ORIGIN =
  process.env.NODE_ENV === "production"
    ? "https://api.umaycicekcilik.com"
    : "https://localhost:7286";

const resolveImageUrl = (url?: string): string => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/")) return API_ORIGIN + url;
  return url;
};

export const useFavoritesStore = defineStore("FavoritesStore", {
  state: () => ({
    favoriteIds: [] as string[],
    favoritesList: [] as any[],
    isLoaded: false,
  }),
  actions: {
    async fetchFavorites() {
      // Sadece kullanıcı giriş yapmışsa çek
      const user = localStorage.getItem("user");
      if (!user) return;

      try {
        const response = await api().get("/Favorites");
        const rawData = response.data?.data || response.data;

        let data: any[] = [];
        if (Array.isArray(rawData)) {
          data = rawData;
        } else if (rawData?.items && Array.isArray(rawData.items)) {
          data = rawData.items;
        }

        console.log("Favoriler API Response:", data);

        if (data.length >= 0) {
          // Gelen veriyi ProductCard bileşeninin beklediği ProductItem formatına dönüştürüyoruz
          this.favoritesList = data.map((item: any) => ({
            ...item,
            id: item.productId || item.id,
            name: item.productName || item.title || item.name,
            price: item.price || item.unitPrice || 0,
            oldPrice: item.oldPrice || item.discountPrice || null,
            mainImage: resolveImageUrl(
              item.mainImage ||
                item.productImage ||
                item.productImageUrl ||
                item.productMainImage ||
                item.productPictureUrl ||
                item.imageUrl ||
                item.pictureUrl ||
                item.thumbnailUrl ||
                item.image ||
                item.product?.mainImage ||
                item.product?.imageUrl ||
                item.product?.thumbnailUrl ||
                item.product?.productImage ||
                item.product?.pictureUrl ||
                "",
            ),
            slug:
              item.slug ||
              item.productSlug ||
              item.product?.slug ||
              item.id ||
              "detay",
          }));
          this.favoriteIds = this.favoritesList.map((f: any) => f.id);
          this.isLoaded = true;
        }
      } catch (error) {
        console.error("Favoriler getirilirken hata oluştu:", error);
      }
    },

    async fetchFavoriteIds() {
      if (!this.isLoaded) {
        await this.fetchFavorites();
      }
    },

    async toggleFavorite(productId: string) {
      try {
        const response = await api().post("/Favorites/Toggle", { productId });
        // Response formatı direkt objede veya .data içinde gelebilir
        let isFavorited = false;
        if (response.data && response.data.isFavorited !== undefined) {
          isFavorited = response.data.isFavorited;
        } else if (
          response.data?.data &&
          response.data.data.isFavorited !== undefined
        ) {
          isFavorited = response.data.data.isFavorited;
        } else if (response.data === true || response.data === false) {
          isFavorited = response.data;
        }

        if (isFavorited) {
          if (!this.favoriteIds.includes(productId)) {
            this.favoriteIds.push(productId);
          }
        } else {
          this.favoriteIds = this.favoriteIds.filter((id) => id !== productId);
          this.favoritesList = this.favoritesList.filter(
            (f) => (f.productId || f.id) !== productId,
          );
        }
        return isFavorited;
      } catch (error) {
        console.error("Favori toggle hatası:", error);
        throw error;
      }
    },

    async checkFavorite(productId: string) {
      try {
        const response = await api().get(`/Favorites/Check/${productId}`);
        let isFavorited = false;
        if (response.data && response.data.isFavorited !== undefined) {
          isFavorited = response.data.isFavorited;
        } else if (
          response.data?.data &&
          response.data.data.isFavorited !== undefined
        ) {
          isFavorited = response.data.data.isFavorited;
        } else if (response.data === true || response.data === false) {
          isFavorited = response.data;
        }

        // Store senkronizasyonu
        if (isFavorited) {
          if (!this.favoriteIds.includes(productId)) {
            this.favoriteIds.push(productId);
          }
        } else {
          this.favoriteIds = this.favoriteIds.filter((id) => id !== productId);
        }
        return isFavorited;
      } catch (error) {
        console.error("Favori kontrol hatası:", error);
        return false;
      }
    },
  },
});
